// extracted by mini-css-extract-plugin
export default {"title":"v1Gs5M","subtitle":"BtE0I7"};